var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRefundError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90449 2.91345C2.91536 2.90237 2.92666 2.8917 2.93836 2.88149C3.17404 2.67521 3.53263 2.68443 3.75734 2.90913L5.424 4.5758C5.65832 4.81012 5.65832 5.19001 5.424 5.42433C5.18969 5.65864 4.80979 5.65864 4.57548 5.42433L3.93291 4.78176V11.3335C3.93291 11.7388 4.26095 12.0669 4.66624 12.0669H8.66624C8.99761 12.0669 9.26624 12.3355 9.26624 12.6669C9.26624 12.9982 8.99761 13.2669 8.66624 13.2669H4.66624C3.59821 13.2669 2.73291 12.4016 2.73291 11.3335V4.78209L2.09067 5.42433C1.85636 5.65864 1.47646 5.65864 1.24214 5.42433C1.00783 5.19001 1.00783 4.81012 1.24214 4.5758L2.90449 2.91345Z",
    fill: "#D43338"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33242 2.7334C7.00105 2.7334 6.73242 3.00203 6.73242 3.3334C6.73242 3.66477 7.00105 3.9334 7.33242 3.9334H11.3324C11.7377 3.9334 12.0658 4.26144 12.0658 4.66673V11.2181L11.0902 10.2425C10.8559 10.0082 10.476 10.0082 10.2417 10.2425C10.0073 10.4768 10.0073 10.8567 10.2417 11.091L12.2343 13.0837C12.2675 13.1181 12.3048 13.1484 12.3453 13.1741C12.4233 13.2234 12.5134 13.2553 12.6102 13.2642C12.7817 13.2801 12.9588 13.2224 13.0902 13.091L15.0902 11.091C15.3245 10.8567 15.3245 10.4768 15.0902 10.2425C14.8559 10.0082 14.476 10.0082 14.2417 10.2425L13.2658 11.2184V4.66673C13.2658 3.59869 12.4005 2.7334 11.3324 2.7334H7.33242Z",
    fill: "#D43338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRefundError);
export default __webpack_public_path__ + "static/media/ArrowRefundError.7bade542c70b56fb8809bbc1da6332a5.svg";
export { ForwardRef as ReactComponent };